import React from "react";
import { useIntl } from "react-intl";
import { PeekBox } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { logPosition } from "./whiskerChartUtils";
import { WhiskerBar } from "./WhiskerBar";
import { WhiskerEmptyState } from "./WhiskerEmptyState";
import { WhiskerEndLabel } from "./WhiskerEndLabel";
import { WhiskerYouMarker } from "./WhiskerYouMarker";
export const WhiskerRangeChart = ({ distribution, yourValue, yourRank, totalCompetitors, }) => {
    const intl = useIntl();
    if (!distribution) {
        return React.createElement(WhiskerEmptyState, null);
    }
    const { min, p25, p50, p75, max } = distribution;
    const q1Pct = logPosition(p25, min, max);
    const medianPct = logPosition(p50, min, max);
    const q3Pct = logPosition(p75, min, max);
    const userPct = logPosition(yourValue, min, max);
    return (React.createElement(PeekBox, { sx: { position: "relative", py: 1, px: 2 } },
        React.createElement(PeekBox, { sx: { display: "flex", alignItems: "center", pt: "44px" } },
            React.createElement(WhiskerEndLabel, { value: String(Math.round(min)), caption: intl.formatMessage(messages.minLabel), tooltipTitle: intl.formatMessage(messages.tooltipMin, { min: Math.round(min) }) }),
            React.createElement(PeekBox, { sx: { position: "relative", flexGrow: 1 } },
                React.createElement(WhiskerYouMarker, { userPct: userPct, yourRank: yourRank, totalCompetitors: totalCompetitors }),
                React.createElement(WhiskerBar, { q1Pct: q1Pct, medianPct: medianPct, q3Pct: q3Pct })),
            React.createElement(WhiskerEndLabel, { value: String(Math.round(max)), caption: intl.formatMessage(messages.maxLabel), tooltipTitle: intl.formatMessage(messages.tooltipMax, { max: Math.round(max) }) }))));
};
export default WhiskerRangeChart;
